import { Injectable } from "@angular/core";
import { TokenModel } from "../models/token.model";
import { SessionService } from "./session.service";

@Injectable({
    providedIn: 'root'
})
export class TokenDataService {
    constructor(
        private sessionService: SessionService
    ) {

    }

    get companyCode(): number {
        return this.getDecodedToken()!.branchCode!;
    }

    get userCode(): number {
        return this.getDecodedToken()!.personcode;
    }

    get tenant(): string {
        return this.getDecodedToken()!.tenant;
    }

    public getDecodedToken(): TokenModel | null {
        const sessionNotification = this.sessionService.isTokenExpiredOrNull();

        if(!sessionNotification.hasAccess)
            return null;

        return sessionNotification.decodedToken;
    }
}